import React from 'react';

import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';

import * as l from "./_csLcl";
import { a } from "./_csAbt";

import * as BtnC from './_cccBtnC';
import * as TblC from './_ccmTblC';
import * as TextC from './_ccbTextC';


import * as ica from 'src/ica';
//import * as icm from 'src/icm';

import * as _cv_10 from './_cv_10___Mz';

let $_10rs = [] as ht.ls;

import * as BtnTopC from './_ccmBtnTopC';
export const B = (pz: ht.btnTopCz) => {
  return (
    cr.c(BtnTopC.N, {
      key: -10,
      ...pz,
      cz: {
        ...pz.cz,
      }
    })
  )
};

export const L = (pz: ht.viewListCz) => {

  React.useEffect(() => {
    f.loadAllAsync({
      frcUdt: pz.sPz.udtAll,
      bfrAsync: () => [
        _cv_10.load_10rLsAsync({
          cdn: pz.cz.cdn,
        })
          .then((_ls: ht.ls) => {
            $_10rs = _ls
          })
      ]
    });
  }, [
    pz.cz.cdn,
  ]);

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewListAbtz[_abtType] ? ica.viewListAbtz[_abtType]() : {};

  const _hdrs = [] as ht.ls;
  const _cellCs = [
    {
      boxStlz: a('f/0.25'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ..._abtz.hdrCz.textCz,
          textz: {
            pfx: 'ID',
          }
        })
      ]
    },
    {
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ..._abtz.hdrCz.textCz,
          textz: {
            pfx: 'スタッフ名'
          }
        })
      ]
    },
    {
      boxStlz: a('f/0.25'),
      oClds: [
      ]
    },
  ];
  _hdrs.push(
    {
      cellCs: _cellCs
    },
  );

  const _rows = [] as ht.ls;
  $_10rs?.map((_10rz: ht.dz) => {
    const _cellCs = [
      {
        boxStlz: a('f/0.25'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: _10rz._icn,
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: _10rz._pfx
            }
          })
        ]
      },
      {
        boxStlz: a('f/0.25'),
        oClds: [
          _10rz._10r_31r1f == pz.cz._31r_fst ?
            cr.c(BtnC.N, {
              key: -10,
              ..._abtz.bdyCz.btnCz,
              lblCz: {
              },
              pslPtyz: {
                onPress: () => {
                  pz.sPz.set({
                    steps: [1],
                    phs: 'dpy',
                    _10r_key: _10rz._key,
                  })
                }
              },
            })
            : undefined,
        ]
      },
    ];
    _rows.push(
      {
        cellCs: _cellCs
      },
    )
  });

  return (
    cr.c(TblC.N, {
      key: -30,
      ..._abtz.tblCz,
      srlCz: {
        srlStlz: {
          otrz: a('dwx/60'),
        },
      },
      hdrCz: {
        lineCs: _hdrs,
      },
      bdyCz: {
        lineCs: _rows,
      },
    })
  );
};
